import Baobab from 'baobab';

var tree = new Baobab({
	query : "",
	results : [
	],
	app : {
    handlers : {
      list : [
      ],
    },
	},
},{
	asynchronous : false,
  immutable: false,
});

window.__state = tree;

export default tree;


// WEBPACK FOOTER //
// ./src/search/app/state.js